import { render, staticRenderFns } from "./RegistrationAndLoginSupportSuccess.vue?vue&type=template&id=f0f69f92&"
import script from "./RegistrationAndLoginSupportSuccess.vue?vue&type=script&lang=js&"
export * from "./RegistrationAndLoginSupportSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports